/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import React from 'react';
import Styles from './elementary-certificate.scss';
const ElemantaryCertificate = ({ name, grade, height = '60vh', width = '83vh' }) => {
    const divStyle = {
        width: width,
        height: height,
        display: 'flex',
        backgroundSize: 'cover'
    };
    return (React.createElement("div", { style: divStyle, className: Styles.elementaryContainer },
        React.createElement("div", { className: Styles.textcontainer },
            React.createElement("img", { className: Styles.logoImg }),
            React.createElement("div", { className: Styles.title }, "Congratulations!"),
            React.createElement("div", { className: Styles.subTitle }, "You have leveled up!"),
            React.createElement("div", { className: Styles.separator }),
            React.createElement("div", { className: Styles.paragraph },
                "You have passed ",
                React.createElement("span", { style: { color: '#F5931F' } }, grade),
                " Grade Finance"),
            React.createElement("div", { className: Styles.name }, name))));
};
export default ElemantaryCertificate;
